import { useSegmentStore } from '@/store/SegmentStore';
import { useSettingsStore } from '@/store/SettingsStore';

export const ConvertFtToMeters = (a) => {
  return parseFloat(a * .3048);
};
export const ConvertMStoFtS = (a) => {
  return parseFloat(a) * 3.2808399;
};
export const ConvertFtStoMS = (a) => {
  return parseFloat(a) / 3.2808399;
};
export const ConvertHaToAcre = (a) => {
  return parseFloat(a * 2.47);
};
export const ConvertM2ToAcre = (a) => {
  return parseFloat(a * 0.000247105);
};
export const ConvertAcreToM2 = (a) => {
  return parseFloat(a / 0.000247105);
};
export const ConvertM2ToHectare = (a) => {
  return parseFloat(a * 0.0001);
};
export const ConvertHectareToM2 = (a) => {
  return parseFloat(a / 0.0001);
};
export const ConvertAcreToHa = (a) => {
  return parseFloat(a / 2.47);
};
export const ConvertMetersToFt = (a) => {
  return parseFloat(a / .3048);
};
export const ConvertMetersToMM = (a) => {
  return parseFloat(a * 1000);
};
export const ConvertMetersToCM = (a) => {
  return parseFloat(a * 100);
};
export const ConvertCMToMeters = (a) => {
  return parseFloat(a / 100);
};
export const ConvertMMToMeters = (a) => {
  return parseFloat(a / 1000);
};
export const ConvertMMtoCM = (a) => {
  return parseFloat(a) / 10;
};
export const ConvertMMtoIN = (a) => {
  return parseFloat(a) / 25.4;
};
export const ConvertMMtoFt = (a) => {
  return parseFloat(a) / 304.8;
};
export const ConvertMetersToIn = (a) => {
  return parseFloat(a / 0.0254);
};
export const ConvertInToMeters = (a) => {
  return parseFloat(a * 0.0254);
};
export const ConvertkPatoPAS = (a) => {
  return parseFloat(a) * 1000;
};
export const ConvertMtoPAS = (a) => {
  return parseFloat(a) * 9806.42;
};
export const ConvertATMtoPAS = (a) => {
  return parseFloat(a) * 101325;
};
export const ConvertFttoPAS = (a) => {
  return parseFloat(a) * 2988.98; 
};
export const ConvertPAStoPSI = (a) => {
  return parseFloat(a) / 6894.75729;
};
export const ConvertPSItoPAS = (a) => {
  return parseFloat(a / 0.000145038);
};
export const ConvertPAStoBAR = (a) => {
  return parseFloat(a * 0.00001);
};
export const ConvertBARtoPAS = (a) => {
  return parseFloat(a / 0.00001);
};
export const ConvertPAStokPa = (a) => {
  return parseFloat(a) / 1000;
};
export const ConvertPAStoATM = (a) => {
  return parseFloat(a) / 101325;
};
export const ConvertPAStoM = (a) => {
  return parseFloat(a) *  0.00010197;
};
export const ConvertPAStoFt = (a) => {
  return parseFloat(a) * 0.00033456;
};
export const ConvertPAStoKgCm2 = (a) => {
  return parseFloat(a) * 0.000010197162129779282;
};
export const ConvertKgCm2toPAS = (a) => {
  return parseFloat(a) / 0.000010197162129779282;
};
// 1 lpm per hectare = 0.106906637 (US gallons per minute) per acre
export const ConvertLPMHtoGPMA = (a) => {
  return parseFloat(a * 0.106906637);
};
export const ConvertGPMAtoLPMH = (a) => {
  return parseFloat(a / 0.106906637);
};
export const ConvertLPMHtoMMPD = (a) => {     // mm/day
  return parseFloat(a * 0.144);
};
export const ConvertLPMHtoINPD = (a) => {     // in/day
  return parseFloat(ConvertLPMHtoGPMA(a) * 0.053030);
};
export const ConvertMMPDtoLPMH = (a) => {     // mm/day
  return parseFloat(a / 0.144);
};
export const ConvertINPDtoGPMA = (a) => {     // in/day
  return parseFloat(a / 0.053030);
};
export const ConvertLPMtoGPM = (a) => {
  return parseFloat(a * 0.26417287472922);
};
export const ConvertLPMtoGPH = (a) => {
  return parseFloat(a) * 15.850323141489;
};  
export const ConvertLPMtoLPH = (a) => {
  return parseFloat(a) * 60;
};
export const ConvertGPMtoLPM = (a) => {
  return parseFloat(a / 0.26417287472922);
};
export const ConvertGPHtoLPM = (a) => {
  return parseFloat(a) / 15.850323141489;
};
export const ConvertLPHtoLPM = (a) => {
  return parseFloat(a) / 60;
};
export const ConvertGPH100FttoLPM = (a) => {
  let pipeLength = useSegmentStore().getAllSegmentLengths('pipe');
  if (useSettingsStore().getLengthUnit === 'm') {
    pipeLength = ConvertMetersToFt(pipeLength);
  } else {
    pipeLength = ConvertFtToMeters(pipeLength);
  }
  return (parseFloat(a * pipeLength)) / 6000;
};
export const ConvertLPH100MtoLPM = (a) => {
  let pipeLength = useSegmentStore().getAllSegmentLengths('pipe');
  if (useSettingsStore().getLengthUnit === 'm') {
    pipeLength = ConvertMetersToFt(pipeLength);
  } else {
    pipeLength = ConvertFtToMeters(pipeLength);
  }
  return (parseFloat(a * pipeLength)) / 8.052;
};
export const ConvertLPMtoLPS = (a) => {
  return parseFloat(a) / 60;
};
export const ConvertPercenttoFt = (a, b) => {
  return ConvertMetersToFt(ConvertPercenttoMeters(a, b));
};
export const ConvertPercenttoMeters = (a, b) => {
  return parseFloat(a / 100) * parseFloat(b);
};
export const ConvertFttoPercent = (a, b) => {
  return ConvertFtToMeters(ConvertMeterstoPercent(a, b));
};
export const ConvertMeterstoPercent = (a, b) => {
  return parseFloat(a) / parseFloat(b) * 100;
};
export const ConvertLPMtoLPH100M = (a) => {
  let pipeLength = useSegmentStore().getAllSegmentLengths('pipe');
  if (useSettingsStore().getLengthUnit === 'm') {
    pipeLength = ConvertMetersToFt(pipeLength);
  } else {
    pipeLength = ConvertFtToMeters(pipeLength);
  }
  return (parseFloat(a / pipeLength)) * 6000;
};
export const ConvertLPMtoGPH100Ft = (a) => {
  let pipeLength = useSegmentStore().getAllSegmentLengths('pipe');
  if (useSettingsStore().getLengthUnit === 'm') {
    pipeLength = ConvertMetersToFt(pipeLength);
  } else {
    pipeLength = ConvertFtToMeters(pipeLength);
  }
  return parseFloat(a / pipeLength) * 8.052;
};
export const ConvertLPStoLPM = (a) => {
  return parseFloat(a) * 60;
};
export const ConvertLPMHtoLPSH = (a) => {
  return parseFloat(a) / 60;
};
export const ConvertLPSHtoLPMH = (a) => {
  return parseFloat(a) * 60;
};
export const ConvertLPMtoM3H = (a) => {
  return parseFloat(a) * 0.06;
};
export const ConvertM3HtoLPM = (a) => {
  return parseFloat(a) / 0.06;
};
export const ConvertLPMMtoGPM100Ft = (a) => {
  return parseFloat(a) * 8.052;
};
export const ConvertLPMMtoGPMFt = (a) => {
  return parseFloat(a) * 0.08052;
};
export const ConvertLPMMtoLPHM = (a) => {
  return parseFloat(a) * 60;
};
export const ConvertLPMMtoLPH100M = (a) => {
  return parseFloat(a) * 6000;
};
export const ConvertINtoMM = (a) => {
  return parseFloat(a) * 25.4;
};
export const ConvertStoMS = (a) => {
  return parseFloat(a) * 1000;
};
export const ConvertStoMins = (a) => {
  return parseFloat(a) / 60;
};
export const ConvertStoHours = (a) => {
  return parseFloat(a) / 3600;
};
export const ConvertStoDays = (a) => {
  return parseFloat(a) / 86400;
};
export const FilterLength = (length, unit) => {
  if (length == null) { return 0; }
  if (unit == 'ft') { return ConvertMetersToFt(length); }
  return length;
};
export const FilterSlope = (pipeLength, slope, unit) => {
  if (slope == null) { return 0; }
  if (unit == 'ft') { return ConvertPercenttoFt(slope, pipeLength); }
  if (unit == 'm') { return ConvertPercenttoMeters(slope, pipeLength); }
  return slope;
};
export const FilterFlow = (flow, unit) => {
  if (flow == null) { return 0; }
  if (unit == 'gpm') { return ConvertLPMtoGPM(flow); }
  if (unit == 'gph') { return ConvertLPMtoGPH(flow); }
  if (unit == 'lph') { return ConvertLPMtoLPH(flow); }
  if (unit == 'm3/h') { return ConvertLPMtoM3H(flow); }
  if (unit == 'm3/m') { return ConvertLPMtoM3H(flow) / 60; }
  if (unit == 'm3/s') { return ConvertLPMtoM3H(flow) / 3600; }
  return flow;
};
export const FilterEmitterFlow = (emitterFlow, unit) => {
  if (emitterFlow == null) { return 0; }
  if (unit == 'gpm') { return ConvertLPMtoGPM(emitterFlow); }
  if (unit == 'gph') { return ConvertLPMtoGPH(emitterFlow); }
  if (unit == 'lph') { return ConvertLPMtoLPH(emitterFlow); }
  if (unit == 'm3/h') { return ConvertLPMtoM3H(emitterFlow); }
  return emitterFlow;
};
export const FilterPressure = (pressure, unit) => {
  if (pressure == null) { return 0; }
  if (unit == 'psi') { return ConvertPAStoPSI(pressure); }
  if (unit == 'kPa') { return ConvertPAStokPa(pressure); }
  if (unit == 'm') { return ConvertPAStoM(pressure); }
  if (unit == 'bar') { return ConvertPAStoBAR(pressure); }
  if (unit == 'kg/cm2') { return ConvertPAStoKgCm2(pressure); }
  if (unit == 'atm') { return ConvertPAStoATM(pressure); }
  if (unit == 'ft') { return ConvertPAStoFt(pressure); }
  return pressure;
};
export const FilterTime = (time, unit) => {
  if  (time == null) { return 0; }
  if  (unit == 'ms') { return ConvertStoMS(time); }
  if  (unit == 'Mins') { return ConvertStoMins(time); }
  if  (unit == 'Hours') { return ConvertStoHours(time); }
  if  (unit == 'Day') { return ConvertStoDays(time); }
  return time;
};
export const FilterDiameter = (diameter, unit) => {
  if (diameter == null) { return 0; }
  if (unit == 'cm') { return ConvertMetersToCM(diameter); }
  if (unit == 'in') { return ConvertMetersToIn(diameter); }
  if (unit == 'mm') { return ConvertMetersToMM(diameter); }
  if (unit == 'ft') { return ConvertMetersToFt(diameter); }
  return diameter;
};
export const FilterVelocity = (velocity, unit) => {
  if (velocity == null) { return 0; }
  if (unit == 'ft/s') { return ConvertMStoFtS(velocity); }
  return velocity;
};
export const UnfilterDiameter = (diameter, unit) => {
  if (diameter == null) { return 0; }
  if (unit == 'cm') { return ConvertCMToMeters(diameter); }
  if (unit == 'in') { return ConvertInToMeters(diameter); }
  if (unit == 'mm') { return ConvertMMToMeters(diameter); }
  if (unit == 'ft') { return ConvertFtToMeters(diameter); }
  return diameter;
};
export const UnfilterLength = (length, unit) => {
  if (length == null) { return 0; }
  if (unit == 'ft') { return ConvertFtToMeters(length); }
  return length;
};
export const UnfilterEmitterFlow = (flow, unit) => {
  if (flow == null) { return 0; }
  if (unit == 'gpm') { return ConvertGPMtoLPM(flow); }
  if (unit == 'gph') { return ConvertGPHtoLPM(flow); }
  if (unit == 'lph') { return ConvertLPHtoLPM(flow); }
  if (unit == 'm3/h') { return ConvertM3HtoLPM(flow); }
  return flow;
};
export const UnfilterPressure = (pressure, unit) => {
  if (pressure == null) { return 0; }
  if (unit == 'psi') { return ConvertPSItoPAS(pressure); }
  if (unit == 'm') { return ConvertMtoPAS(pressure); }
  if (unit == 'kPa') { return ConvertkPatoPAS(pressure); }
  if (unit == 'bar') { return ConvertBARtoPAS(pressure); }
  if (unit == 'kg/cm2') { return ConvertKgCm2toPAS(pressure); }
  if (unit == 'atm') { return ConvertATMtoPAS(pressure); }
  if (unit == 'ft') { return ConvertFttoPAS(pressure); }
  return pressure;
};
export const UnfilterVelocity = (velocity, unit) => {
  if (velocity == null) { return 0; }
  if (unit == 'ft/s') { return ConvertFtStoMS(velocity); }
  return velocity;
};
export const UnfilterSlope = (pipeLength, slope, unit) => {
  if (slope == null) { return 0; }
  if (unit == 'ft') { return ConvertFttoPercent(slope, pipeLength); }
  if (unit == 'm') { return ConvertMeterstoPercent(slope, pipeLength); }
  return slope;
};
// Flow Conversions
export const FlowFromRate = (rate, length, arc, runLength) => {
  if (runLength == 0 && length == 0)
    { return 0; }
  // rate = export const ConvertLPMtoGPM(rate);
  if (runLength == 0 || runLength == null)
    { return rate * Math.PI * (Math.pow(length, 2) / 10000) * (arc / 360); }
  else
    { return rate * length * (runLength / 10000); }
};
export const FlowFromRadius = (L, r, Qtot, AppRate) => {// Machine Length, EG Radius, TotalFlow, AppRate
  if (AppRate == null)// Caclulate from Qtot
  {
    AppRate = (Qtot * 10000) / (Math.pow((L + r), 2) * Math.PI); // lpm/ha
  }
  var Qgun = (AppRate * Math.PI * (Math.pow((L + r), 2) - Math.pow(L, 2))) / 10000;// lpm
  return Qgun;
};
export const RadiusFromFlow = (L, Qgun, Qtot, AppRate) => {// Machine Length, EG Flow, TotalFlow, AppRate
  if (AppRate == null)// Calculate from flow
  {
    AppRate = ((Qtot - Qgun) * 10000) / (Math.PI * Math.pow(L, 2)); // lpm/ha
  }
  else if (Qtot == null)// Calculate from Rate
  {
    Qtot = ((AppRate * Math.PI * Math.pow(L, 2)) / 10000) + Qgun;
  }
  var radiusAdjusted = Math.sqrt((Qtot * 10000) / (AppRate * Math.PI)) - L;
  return radiusAdjusted;
};
export const translateImportLength = (len, units) => {
  switch (units) {
    case 'ft':
      return ConvertFtToMeters(len);
    case 'm':
      return parseFloat(len);
  }
};
export const translateImportPressure = (press, units) => {
  switch (units) {
    case 'psi':
      return ConvertPSItoPAS(press);
    case 'bar':
      return ConvertBARtoPAS(press);
  }
};
export const translateImportFlow = (flow, units) => {
  switch (units) {
    case 'gpm':
      return ConvertGPMtoLPM(flow);
    case 'lpm':
      return parseFloat(flow);
    case 'm�/hr':
      return ConvertM3HtoLPM(flow);
    case 'm3/hr':
      return ConvertM3HtoLPM(flow);
  }
};
export const translateImportDia = (dia, units) => {
  switch (units) {
    case 'in':
      return ConvertInToMeters(dia);
    case 'cm':
      return parseFloat(dia) * 0.01;// cm to m
    case 'mm':
      return ConvertMMToMeters(dia);
  }
};